import BillingInfoForm from './BillingInfoForm';
import './BillingInfoForm.css';

export default BillingInfoForm;



// WEBPACK FOOTER //
// ./src/shared/components/BillingInfoForm/index.js